export const PAGE_SIZE = 10;

export const payrollPagination = (query, total) => ({
  current: query.page,
  pageSize: query.count,
  total,
  showTotal: (value) => `Total: ${value} items`,
  showQuickJumper: true,
  showSizeChanger: true,
  pageSizeOptions: [10, 20, 25, 50, 100],
});

// Handle pagination only once: Table also fires onChange when its pager changes.
export const tableQueryChange = (pagination, sorter, extra, query) => {
  if (extra.action === "paginate") {
    return { page: pagination.pageSize !== query.count ? 1 : pagination.current, count: pagination.pageSize };
  }
  return {
    page: 1,
    sortField: sorter.columnKey || sorter.field || query.sortField,
    sortOrder: sorter.order === "descend" ? "desc" : "asc",
  };
};

export const maintenanceDetailHref = (id) => `#/JobRequests/Maintenance/Details?${new URLSearchParams({ id: String(id) })}`;
